import React, { useContext } from 'react';
import { GenericSquare } from '../../generic/square';
import { COLORS } from '../../constants';
import { LabelWithIcon } from '../../generic/label-with-icon';
import { ComponentContext } from '../../contexts/components-context';
export const Rectangle = ({ definition }) => {
    const { width, height, cornerRadius, text, icon, strokeWidth, strokeColor, fillColor } = definition;
    const { SelectionMarker } = useContext(ComponentContext);
    return (React.createElement("svg", { style: { pointerEvents: 'all' } },
        React.createElement(GenericSquare, { width: width, height: height, cornerRadius: cornerRadius, strokeWidth: strokeWidth, strokeColor: strokeColor || COLORS.DEFAULT_STROKE, fill: fillColor || COLORS.FILL, notBounding: true }),
        text || icon ? React.createElement(LabelWithIcon, { definition: definition }) : null,
        React.createElement(SelectionMarker, { width: width, height: height })));
};
//# sourceMappingURL=rectangle.js.map